
// 全局配置

// 数据源 URL
// 如果数据托管在 Cloudflare R2 或其他 CDN 上，请修改此 URL
// 例如: 'https://data.yourdomain.com/data.json'
// 默认为本地开发服务器上的路径
// 在开发环境中使用相对路径，确保加载本地生成的 data.json
export const DATA_URL = '/data/data.json';

// 应用名称和Slogan
export const APP_NAME = '多棱镜';
export const APP_SLOGAN = '您身边的信号专家';

// 加密密钥 (必须与 scripts/generate_data.ts 中的保持一致)
// 注意: 在生产环境中，密钥不应直接暴露在前端代码中，建议通过环境变量注入

// 但对于此演示项目，我们直接放在这里
export const SECRET_KEY = 'YOUR_SECRET_KEY_HERE';
